export default __webpack_public_path__ + "assets/hill5.png";